const landSpeckData = {
  id: "land-and-speck",
  title: "Land and Speck Guides",
  category: "Guides",
  slug: "lands",
  meta: {
    description: "A comprehensive guide about Lands and Specks inside of the Pixels game",
    keywords: ["beginner", "Pixels", "game", "land", "speck", "limits"],
    author: "PixeLore",
    date: "2025-04-23",
  },
  sections: [
    {
      id: "lands",
      title: "Lands",
      type: "section",
      content: [
        {
          type: "subdivision",
          id: "about-pixels-lands",
          title: "About Pixels Lands",
          content: [
            {
              type: "text",
              data: "There are 5000 NFT Farm Lands made specifically for the game Pixels. They were minted on January 31 2022 for 0.06 ETH to players of their Play-to-Mint. Top 2000 players of the Play-to-Mint could purchase 2 lands, and everyone else could mint 1. 200 Lands were kept in reserve.",
            },
            {
              type: "text",
              data: "Top 101 Players of the Play-to-Mint also received a Golden Rake.",
            },
            {
              type: "text",
              data: "Land NFTs have 7 traits: Size, Environment, House, Tree Density, Windmill, Coop, and Silo. Every land comes with a Quonset Hut which is essential for storing the land's surplus. Surplus is a percentage of resources used on a farm land. (Not a tax, but it's like extra generation from a player utilizing an industry on your land). Since Pixels is a growing game that proudly boasts building in public, trait values change in importance as things change within the game.",
            },
            {
              type: "text",
              data: `Land owners can also place industries, decor, and other items on their land to make it more attractive or more useful.<br/>
                Lands are not necessary to play the game, but it opens up a new avenue for players. Being a land owner also has its own perks at times.`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "traits",
          title: "Traits",
          content: [
            {
              type: "table",
              usesRowSpan: "trait",
              data: [
                {
                  trait: "Size",
                  options: "Small",
                  amount: "19% - 950",
                  benefits: "Determines the amount of space on a land",
                  rowSpan: 2,
                },
                {
                  trait: "Size",
                  options: "Large",
                  amount: "81% - 4050",
                  benefits: "",
                  rowSpan: 2,
                },
                {
                  trait: "House",
                  options: "Small",
                  amount: "61% - 3050",
                  benefits: "4 Floors",
                  rowSpan: 2,
                },
                {
                  trait: "House",
                  options: "Large",
                  amount: "39% - 1950",
                  benefits: "5 Floors and a solarium",
                  rowSpan: 2,
                },
                {
                  trait: "Environment",
                  options: "Land",
                  amount: "50.5% - 2524",
                  benefits: "",
                  rowSpan: 3,
                },
                {
                  trait: "Environment",
                  options: "Water",
                  amount: "38.6% - 1931",
                  benefits: "Mines: Salt. Farming: Watermints",
                  rowSpan: 3,
                },
                {
                  trait: "Environment",
                  options: "Space",
                  amount: "10.9% - 545",
                  benefits: "Mines: Voidtonium. Farming: Astracactus",
                  rowSpan: 3,
                },
                {
                  trait: "Tree Density",
                  options: "Light",
                  amount: "70% - 3500",
                  benefits: "Trees have slightly higher drop rate.",
                  rowSpan: 3,
                },
                {
                  trait: "Tree Density",
                  options: "Dense",
                  amount: "16% - 800",
                  benefits: "Trees have a higher drop rate",
                  rowSpan: 3,
                },
                {
                  trait: "Tree Density",
                  options: "None",
                  amount: "14% - 700",
                  benefits: "Trees have similar drop rates as Specks",
                  rowSpan: 3,
                },
                {
                  trait: "Coop",
                  options: "Yes",
                  amount: "49% - 2450",
                  benefits: "Currently, these are the only lands with a Coop.",
                  rowSpan: 2,
                },
                {
                  trait: "Coop",
                  options: "No",
                  amount: "51% - 2550",
                  benefits: "",
                  rowSpan: 2,
                },
                {
                  trait: "Windmill",
                  options: "Yes",
                  amount: "51% - 2550",
                  benefits: "Currently, these are the only lands with a Windmill.",
                  rowSpan: 2,
                },
                {
                  trait: "Windmill",
                  options: "No",
                  amount: "49% - 2450",
                  benefits: "",
                  rowSpan: 2,
                },
                {
                  trait: "Silo",
                  options: "Yes",
                  amount: "50% - 2500",
                  benefits: "Silo provides more space for Surplus [36 instead of 24]",
                  rowSpan: 2,
                },
                {
                  trait: "Silo",
                  options: "No",
                  amount: "50% - 2500",
                  benefits: "",
                  rowSpan: 2,
                },
              ],
            },
            {
              type: "text",
              data: `On top of traits, Lands go up to Tier 4. So you can place industries from Tier 1 to Tier 4 on the land.<br/>
                Land Space is determined by its size and limit. Each land has limits for Producers, Crafting, Pet Care and Business Industries<br/>`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "surplus",
          title: "Surplus",
          content: [
            {
              type: "text",
              data: `<strong>What Is Surplus?</strong> Surplus is a great benefit to owning a land. It's like getting back resources that were produced on your land without needing to gather them yourself.<br/>
                 <strong>How does it work?</strong> The way it works is each land has a surplus set of 30%-45% chance (Updated from 8-12% on Jan 21 2026). So for every 100 resources produced, there's a % chance of receiving a duplicate of that resource.<br/>
                  The lowest part of the range is for lands that are low in level, and the higher part of the range is for the maximum level.<br/>
                  If you have level 0 Mining, you get 30% Surplus from Mining on land. (same for farming, forestry or animal care)<br/><br/>
                  But if you have level 100 Mining, you get 45% surplus from Mining on land. (same for farming, forestry or animal care)<br/>
                  So if you have Level 0 on Farming and Level 100 on Mining, you'll only get 45% Change for Mining, and 8% chance for Farming<br/><br/>
                  <strong>Where to collect the surplus?</strong> Surplus goes to the metal building on your land, or the Silo if you own one. Both the Silo and the Quonset Hut show the same surplus.<br/>
                  <strong>Pro Tip:</strong> Items stack up to 999 as Surplus! Even if you don't have 999 Stacks for your VIP Upgrades
                  <br/><br/>Also you can increase your surplus chances using <a href="/wiki/lands/discoverability" target="_blank" class="wiki-links">discoverability items!</a>`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "land-owner-perks",
          title: "Land Owner Perks",
          content: [
            {
              type: "list",
              data: `1 Extra Bookmark
                        6 Extra Bag Space 
                        Land Owner Tasks on Task Board (After 24 Hours)
                        Reduced Withdrawal Fees and Marketplace Fees
                        5 Additional MP listing slots
                        Easy access to lands in Lands Tab
                        Quantum Recombinator Access
                        Land Surplus
                        Land Owner Reputation (After 14 days of holding)
                        All Tier 1 VIP perks after 7 days holding (renews daily)`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "land-settings",
          title: "Land Settings",
          content: [
            {
              type: "text",
              data: `Every NFT Land has its own access settings. A land owner can add a builder or manager to its land, make the land private, or give a guild access to the land.<br/>
                    You can do all of these things at the Gate which is located at the entrance of the land.<br/><br/>

                    Land Access Settings: A Manager has rights to do everything on a land, except access storage chests. They can remove/add industries or decorations, access surplus or change settings of the land.<br/>
                    A Builder can add items to a land, but cannot remove them (though if they placed the item, they can still remove it). They cannot access surplus or manage settings.<br/>
                    Giving access to a guild makes the land locked to everyone except players in that guild (You can further limit this by setting it to either Pledgers, Supporters, etc.)`,
            },
            {
              type: "table",
              data: [
                {
                  type: "<b>Owner</b>",
                  "Add Managers": "Yes",
                  "Add Builers": "Yes",
                  "Use Chests": "Yes",
                  "Use Surplus": "Yes",
                  "Add Industries/Decor": "Yes",
                  "Use Mover": "Yes",
                  "Use Remover": "Yes",
                  "Remove Own Items": "Yes",
                  "Use Land": "Yes",
                },
                {
                  type: "<b>Manager</b>",
                  "Add Managers": "Yes",
                  "Add Builers": "Yes",
                  "Use Chests": "No",
                  "Use Surplus": "Yes",
                  "Add Industries/Decor": "Yes",
                  "Use Mover": "Yes",
                  "Use Remover": "Yes",
                  "Can Remove Own Items": "Yes",
                  "Use Land": "Yes",
                },
                {
                  type: "<b>Builder</b>",
                  "Add Managers": "No",
                  "Add Builers": "No",
                  "Use Chests": "No",
                  "Use Surplus": "No",
                  "Add Industries/Decor": "Yes",
                  "Use Mover": "Yes",
                  "Use Remover": "No",
                  "Can Remove Own Items": "Yes",
                  "Use Land": "Yes",
                },
                {
                  type: "<b>Everyone Else</b>",
                  "Add Managers": "No",
                  "Add Builers": "No",
                  "Use Chests": "No",
                  "Use Surplus": "No",
                  "Add Industries/Decor": "No",
                  "Use Mover": "No",
                  "Use Remover": "No",
                  "Can Remove Own Items": "Yes",
                  "Use Land": "Yes",
                },
                {
                  type: "<b>Blocked</b>",
                  "Add Managers": "No",
                  "Add Builers": "No",
                  "Use Chests": "No",
                  "Use Surplus": "No",
                  "Add Industries/Decor": "No",
                  "Use Mover": "No",
                  "Use Remover": "No",
                  "Can Remove Own Items": "Yes",
                  "Use Land": "No",
                },
              ],
            },
          ],
        },
        {
          type: "subdivision",
          id: "item-ownership",
          title: "Ownership of Items on Lands",
          content: [
            {
              type: "text",
              data: `Whoever places an industry on a land (or a decor) is the person that the item will go back to when it is removed.
                        <br/>Common Complaints are seen that this doesn't apply to the Pixel Board or the Christmas Tree. Remove your stuff before you lose access to a land you don't own!
                        <br/>Also stuff in the house is kinda hard to get back if you don't have access to the land (˶˃⤙˂˶)`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "where-to-buy-land",
          title: "Where to buy land?",
          content: [
            {
              type: "text",
              data: `Lands on Ronin can be purchased on the <a href="https://marketplace.skymavis.com/collections/pixels-farmland/" target="_blank" rel="noreferrer" class="wiki-links">Ronin Marketplace</a>, and lands on ETH can be purchased on the Ethereum Chain via <a href="https://blur.io/eth/collection/pixels-farm" target="_blank" rel="noreferrer" class="wiki-links">Blur</a>, <a href="https://opensea.io/collection/pixels-farm" target="_blank" rel="noreferrer" class="wiki-links">OpenSea</a> or any other marketplace available
                    <br/>There is no difference between the lands on ETH vs Ronin except the chain where they're located and possibly the price.`,
            },
          ],
        },
        {
          type: "subdivision",
          id: "land-rental",
          title: "Land Rental",
          content: [
            {
              type: "text",
              data: `You can rent your land out if you're not using it, or you can rent a land for yourself and you'll be seen as a land owner to the game.<br/>
              If you do list your only land, you will lose land owner benefits while the land is listed.<br/>
                    Land Rentals are most popularly done on <a href="https://www.lootrush.com" target="_blank" rel="noreferrer" class="wiki-links">LootRush</a><br/><br/>

                    After you've rented a land, you should see it in game immediately if the right wallet is connected. If you've rented out your land, you should immediately lose access to it in game, and another player will then have access. The other player will not get builder or manager status.`,
            },
          ],
        },
      ],
    },
    {
      id: "specks",
      title: "Specks",
      type: "section",
      content: [
        {
          title: "Specks In Pixels",
          id: "specks-in-pixels",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Speck Lands are small free lands that every player starts with when they open an account. <br/>
              After the tutorial, Barney sends the player to their Speck Land and in the early parts of the game, this might be the most common location for a player!<br/>
                Each Speck starts with a small house, 4 Trees, 6 Soils, and a Tier 1 Mine.<br/>
                Speck NFTs are tiny lands that are accessible to everyone - they are smaller, don't have land traits and they don't generate surplus.<br/>
                And while friends can visit your Speck, they can't use any of the industries on them`,
            },
          ],
        },
        {
          title: "Tiers",
          type: "subdivision",
          id: "tiers",
          content: [
            {
              type: "text",
              data: `A speck can have up to Tier 2 Industries. For higher than Tier 2, a player must use an NFT Land.<br/>
                    These tiers come at different costs per house and Speck. Every house and speck has upgrades, and these upgrades can have either Tier 1 or Tier 2.`,
            },
            {
              type: "table",
              data: [
                {
                  upgrade: "Micro",
                  type: "Land",
                  cost: "Free",
                  size: "104 Tiles",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Mini",
                  type: "Land",
                  cost: "5,000 Coins",
                  size: "170 Tiles",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Teeny",
                  type: "Land",
                  cost: "50,000 Coins",
                  size: "252 Tiles",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Tiny",
                  type: "Land",
                  cost: "100,000 Coins",
                  size: "350 Tiles",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Petite",
                  type: "Land",
                  cost: "200,000 Coins",
                  size: "464 Tiles",
                  tier: "Tier 1 & 2",
                },
                {
                  upgrade: "Pocket",
                  type: "Land",
                  cost: "25 $PIXEL",
                  size: "594 Tiles",
                  tier: "Tier 1 & 2",
                },
                {
                  upgrade: "Small Interior",
                  type: "House",
                  cost: "Free",
                  size: "1 Floor",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Medium Interior",
                  type: "House",
                  cost: "16 $PIXEL",
                  size: "2 Floors",
                  tier: "Tier 1",
                },
                {
                  upgrade: "Large Interior",
                  type: "House",
                  cost: "160 $PIXEL",
                  size: "3 Floors",
                  tier: "Tier 1 & 2",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "discoverability",
      title: "Discoverability",
      type: "section",
      content: [
        {
          title: "Discoverability of Lands & Specks",
          id: "disc-lands-specks",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Some items in game have a special little attachment on them called discoverability points. They're not on everything, but they're on some items, and you can place them on your land to increase the Discoverability.
                  <hr class="wiki-hr"/>
                  <br/>
                  As of July 29th, 2025, Discoverability Points can now increase your land's surplus. Before this, their only purpose was to get higher on the <span class="top-farms-board-container z-[100]">
                    <span>Top Farms Board</span>
                    <img src="https://pixelore.s3.eu-central-003.backblazeb2.com/Guide+Images/image_2025-05-02_194122195.png" alt="Top Farms Board" class="top-farms-board-image" />
                  </span> ✧｡٩(ˊᗜˋ)و✧*｡ sometimes players use the board to find lands or just to visit. They once used the Top Farms to place Easter Eggs for an event.`,
            },
          ],
        },
        {
          title: "Which Items Have Discoverability Points?",
          id: "disc-items",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `These are the items that I know of that have points in the game:`,
            },
            {
              type: "component",
              data: `DiscItems`,
            },
          ],
        },
        {
          title: "How Much Surplus do they give?",
          id: "disc-surplus",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `You can see how much Farm Charm Points you have by visiting your land and looking at the gate. This surplus % is an addition to the already base surplus the game naturally gives.`
            },
            {
              type: "table",
              data: [
                {
                  "Farm Charm Points": 20000,
                  surplus: "3%",
                },
                {
                  "Farm Charm Points": 40000,
                  surplus: "6%",
                },
                {
                  "Farm Charm Points": 60000,
                  surplus: "9%",
                },
                {
                  "Farm Charm Points": 80000,
                  surplus: "12%",
                },
                {
                  "Farm Charm Points": 100000,
                  surplus: "15%",
                },
                {
                  "Farm Charm Points": 120000,
                  surplus: "18%",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: "boosts",
      title: "Land Boosts",
      type: "section",
      content: [
        {
          title: "What Are Land Boosts?",
          id: "land-boosts",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Land Boosts are items that were introduced into the game during the Winter Carnival that offer some form of "boost" to the industry production on a land. You place them on a land, and they become active depending on their type.`,
            },
            {
              type: "text",
              data: `You can only have 2 Boosts at a time per industry. Here's some examples:<br/>
              🗽 You can have 1 Farming Yield Boost and 1 Farming Speed Boost.<br/>
              🗽 You can have 2 Stoneshaping Speed Boosts, 2 Farming Yield Boosts, and 2 Forestry Yield Boosts because you're at the maximum for each industry</br/>
              🗽 You can also mix and match between yield and speed boosts per industry.<br/>
              🚫 You can't have 2 Yield Boost and 2 Speed Boosts for the same industry.<br/>
              🚫 You can't have 3 Yield Boosts for the same industry or 3 Speed Boosts for the same industry.
              `,
            },
          ],
        },
        {
          title: "Types of Land Boosts?",
          id: "land-boost-types",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `There are currently two types of Land Boosts. Speed and Yield.`,
            },
            {
              type: "inlineLink",
              data: {
                text: "Forestry Ice Sculpture",
                itemId: "itm_bstB02",
                description: `🕝 <b>Speed</b>: Speed Boosts speed up the production of items by a percentage.<br/>
              For example, if a sculpture gives 5% boost, then it takes 5% of time off of the production time of the related industry.<br/>
              If I place a Forestry Ice Sculpture, then the time for a tree to grow back decreases by 5%.<br/><br/>`,
              },
            },
            {
              type: "inlineLink",
              data: {
                text: ["Apiary Tiki Sculpture", "Golden Rake"],
                itemId: ["itm_bstA06", "itm_goldenRake"],
                description: `✨ <b>Yield</b>: Yield Boosts have a % chance of giving double your production.<br/>
              For example, if a sculpture has 6% Yield Boost, then there's a 6% chance that your next harvest will be a double up!<br/>
              If I place an Apiary Tiki Sculpture on a land with Apiaries, anyone using those apiaries has a chance of getting 6 Honey instead of 3, or 2 Queen Bees instead of 1.<br/><br/>
              <b>Fun Fact:</b> Yield Boosts + Golden Rake can stack, increasing the chance even more.`,
              },
            },
          ],
        },
        {
          title: "Surplus and Boosts",
          id: "surplus-and-boosts",
          type: "subdivision",
          content: [
            {
              type: "inlineLink",
              data: {
                text: "Golden Rake",
                itemId: "itm_goldenRake",
                description: `With speed boosts, these have no real effect on surplus. But the yield boost does!
                <br/>If you collect items with a yield boost, and that yield got boosted (for eg, you got 2 crops instead of 1, or you get 6 Honey instead of 3), and on that same drop the surplus would have increased, then the surplus receives extra also!
                <br/><br/>
                If you collect extra produce on the same drop that would've counted for surplus, the surplus would receive that same extra.<br/>
                <b>Pro Tip:</b> The same happens if someone uses the Golden Rake!`,
              },
            },
          ],
        },
      ],
    },
    {
      id: "limits",
      title: "Land Limits",
      type: "section",
      content: [
        {
          title: "What are Land Limits?",
          id: "land-limits",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `Land Limits were introduced to Pixels in Chapter 2.5 on January 28th, 2025. <br/>
              This was a move made by the Pixels team to tighten up on resource scarcity, and introduce limited industries per land to allow more social interaction across the board.`,
            },
            {
              type: "text",
              data: `In basic terms, it means you can only have a certain number of industries on your land, or you'll see "Limit Reached"<br/>
              If you get a message saying "Limit Reached!" when you try to use industries, you've gone over that limit! Remove some industries from the land until all the Build Limits are 100% or under.`,
            },
          ],
        },
        {
          title: "What are the Limits?",
          id: "land-limits-actuals",
          type: "subdivision",
          content: [
            {
              type: "text",
              data: `These are the current limits known of in the game:`,
            },
            {
              type: "table",
              data: [
                {
                  Industry: "Soils",
                  Type: "Producer",
                  "NFT Large": 133,
                  "NFT Small": 90,
                  "Pocket Speck": 66,
                  "Petite Speck": "",
                  "Tiny Speck": 47,
                  "Teeny Speck": 37,
                  "Mini Speck": "",
                  "Micro Speck": "",
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T1 Mines",
                  Type: "Producer",
                  "NFT Large": 20,
                  "NFT Small": 13,
                  "Pocket Speck": 10,
                  "Petite Speck": "",
                  "Tiny Speck": 7,
                  "Teeny Speck": 5,
                  "Mini Speck": "",
                  "Micro Speck": "",
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T2 Mines",
                  Type: "Producer",
                  "NFT Large": 13,
                  "NFT Small": 9,
                  "Pocket Speck": 6,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T3 Mines",
                  Type: "Producer",
                  "NFT Large": 10,
                  "NFT Small": 6,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T4 Mines",
                  Type: "Producer",
                  "NFT Large": 8,
                  "NFT Small": 5,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T1 Trees",
                  Type: "Producer",
                  "NFT Large": 66,
                  "NFT Small": 45,
                  "Pocket Speck": 33,
                  "Petite Speck": "",
                  "Tiny Speck": 23,
                  "Teeny Speck": 4,
                  "Mini Speck": "",
                  "Micro Speck": "",
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T2 Trees",
                  Type: "Producer",
                  "NFT Large": 58,
                  "NFT Small": 38,
                  "Pocket Speck": 28,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T3 Trees",
                  Type: "Producer",
                  "NFT Large": 50,
                  "NFT Small": 33,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T4 Trees",
                  Type: "Producer",
                  "NFT Large": 43,
                  "NFT Small": 30,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T1 SS/WW/MW",
                  Type: "Crafting",
                  "NFT Large": 20,
                  "NFT Small": 13,
                  "Pocket Speck": 8,
                  "Petite Speck": "",
                  "Tiny Speck": 5,
                  "Teeny Speck": 4,
                  "Mini Speck": "",
                  "Micro Speck": "",
                  "NFT House Large": 13,
                  "NFT House Small": 10,
                  "Large Interior": 10,
                  "Medium Interior": 8,
                  "Small Interior": 6,
                },
                {
                  Industry: "T2 SS/WW/MW",
                  Type: "Crafting",
                  "NFT Large": 14,
                  "NFT Small": 10,
                  "Pocket Speck": 6,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 10,
                  "NFT House Small": 7,
                  "Large Interior": 8,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T3 SS/WW/MW",
                  Type: "Crafting",
                  "NFT Large": 12,
                  "NFT Small": 8,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 8,
                  "NFT House Small": 6,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T4 SS/WW/MW",
                  Type: "Crafting",
                  "NFT Large": 10,
                  "NFT Small": 6,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 6,
                  "NFT House Small": 5,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T1 Stoves",
                  Type: "Crafting",
                  "NFT Large": 0,
                  "NFT Small": 0,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 20,
                  "NFT House Small": 15,
                  "Large Interior": 15,
                  "Medium Interior": 8,
                  "Small Interior": 10,
                },
                {
                  Industry: "T2 Stoves",
                  Type: "Crafting",
                  "NFT Large": 0,
                  "NFT Small": 0,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 13,
                  "NFT House Small": 10,
                  "Large Interior": 10,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T3 Stoves",
                  Type: "Crafting",
                  "NFT Large": 0,
                  "NFT Small": 0,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 10,
                  "NFT House Small": 7,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "T4 Stoves",
                  Type: "Crafting",
                  "NFT Large": 0,
                  "NFT Small": 0,
                  "Pocket Speck": 0,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 8,
                  "NFT House Small": 6,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "Textile Mill",
                  Type: "Crafting",
                  "NFT Large": 23,
                  "NFT Small": 15,
                  "Pocket Speck": 10,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "Grills (All)",
                  Type: "Crafting",
                  "NFT Large": 125,
                  "NFT Small": "",
                  "Pocket Speck": 50,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "Winery (All)",
                  Type: "Business",
                  "NFT Large": 1,
                  "NFT Small": 1,
                  "Pocket Speck": "",
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "Slug Hutch",
                  Type: "Animal Care",
                  "NFT Large": 4,
                  "NFT Small": 3,
                  "Pocket Speck": 2,
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
                {
                  Industry: "Apiary",
                  Type: "Animal Care",
                  "NFT Large": 26,
                  "NFT Small": "",
                  "Pocket Speck": "",
                  "Petite Speck": 0,
                  "Tiny Speck": 0,
                  "Teeny Speck": 0,
                  "Mini Speck": 0,
                  "Micro Speck": 0,
                  "NFT House Large": 0,
                  "NFT House Small": 0,
                  "Large Interior": 0,
                  "Medium Interior": 0,
                  "Small Interior": 0,
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default landSpeckData;
